import { render } from "./TwitterLayout.vue?vue&type=template&id=4ac0b565&scoped=true&ts=true"
import script from "./TwitterLayout.vue?vue&type=script&lang=ts"
export * from "./TwitterLayout.vue?vue&type=script&lang=ts"

import "./TwitterLayout.vue?vue&type=style&index=0&id=4ac0b565&lang=css"
import "./TwitterLayout.vue?vue&type=style&index=1&id=4ac0b565&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac0b565"]])

export default __exports__